export default "__VITE_ASSET__CrGiB98U__"